// src/api/students.ts

import { apiClient } from './client';
import {
    Student, ApiResponse, CreateStudentDto, UpdateStudentDto,
    CreateStudentResponse, Invitation
} from '../types';

export const studentsApi = {
    // Получить всех активных учеников
    getAll: async (): Promise<ApiResponse<Student[]>> => {
        return apiClient.get<Student[]>('/students');
    },

    // Получить всех учеников (включая неактивных)
    getAllWithInactive: async (): Promise<ApiResponse<Student[]>> => {
        return apiClient.get<Student[]>('/students/all');
    },

    // Получить ученика по ID
    getById: async (id: number): Promise<ApiResponse<Student>> => {
        return apiClient.get<Student>(`/students/${id}`);
    },

    // Создание студента (обновлено — возвращает CreateStudentResponse)
    create: async (data: CreateStudentDto): Promise<ApiResponse<CreateStudentResponse>> => {
        return apiClient.post<CreateStudentResponse>('/students', data);
    },

    // Перегенерация приглашения
    regenerateInvitation: async (id: number): Promise<ApiResponse<Invitation>> => {
        return apiClient.post<Invitation>(`/students/${id}/invitation`);
    },

    // Обновить ученика
    update: async (id: number, data: UpdateStudentDto): Promise<ApiResponse<Student>> => {
        return apiClient.put<Student>(`/students/${id}`, data);
    },

    // Активировать ученика
    activate: async (id: number): Promise<ApiResponse<Student>> => {
        return apiClient.post<Student>(`/students/activate/${id}`);
    },

    // Деактивировать ученика
    deactivate: async (id: number): Promise<ApiResponse<Student>> => {
        return apiClient.post<Student>(`/students/deactivate/${id}`);
    },

    // удалить ученика полностью
    delete: async (id: number): Promise<ApiResponse<void>> => {
        return apiClient.delete<void>(`/students/${id}`);
    },
};